import { SvgProps } from "../../types";

const TimeLineSvg = (props: SvgProps) => (
  <svg
    {...props}
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.6 19L13.9 14.3C13.2167 14.8333 12.4625 15.25 11.6375 15.55C10.8125 15.85 9.93333 16 9 16C7.5 16 6.14583 15.6333 4.9375 14.9C3.72917 14.1667 2.775 13.2 2.075 12H4.525C5.09167 12.6167 5.75417 13.1042 6.5125 13.4625C7.27083 13.8208 8.1 14 9 14C10.6667 14 12.0833 13.4167 13.25 12.25C14.4167 11.0833 15 9.66667 15 8C15 6.33333 14.4167 4.91667 13.25 3.75C12.0833 2.58333 10.6667 2 9 2C7.43333 2 6.07917 2.52917 4.9375 3.5875C3.79583 4.64583 3.15833 5.95 3.025 7.5H1.025C1.15833 5.38333 1.9875 3.60417 3.5125 2.1625C5.0375 0.720833 6.86667 0 9 0C11.2333 0 13.125 0.775 14.675 2.325C16.225 3.875 17 5.76667 17 8C17 8.93333 16.85 9.8125 16.55 10.6375C16.25 11.4625 15.8333 12.2167 15.3 12.9L20 17.6L18.6 19ZM7.925 12L6.35 6.8L5.05 10.5H0V9H4L5.65 4.25H7.15L8.675 9.35L9.75 6H11.25L12.75 9H13.5V10.5H11.825L10.65 8.15L9.4 12H7.925Z"
      fill={props.fill ? props.fill : "#1064ED"}
    />
  </svg>
);
export default TimeLineSvg;
